type XIconProps = {
  className?: string;
  fill?: string;
};

const XIcon = ({ className, fill = "#212121" }: XIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12.0057 13.388L11.9969 13.3792L11.988 13.388L7.08804 18.288C6.90728 18.4688 6.67723 18.5594 6.39688 18.5594C6.11652 18.5594 5.88647 18.4688 5.70571 18.288C5.52495 18.1073 5.43438 17.8772 5.43438 17.5969C5.43438 17.3165 5.52495 17.0865 5.70571 16.9057L10.6057 12.0057L10.6146 11.9969L10.6057 11.988L5.70571 7.08804C5.52495 6.90728 5.43438 6.67723 5.43438 6.39688C5.43438 6.11652 5.52495 5.88647 5.70571 5.70571C5.88647 5.52495 6.11652 5.43438 6.39688 5.43438C6.67723 5.43438 6.90728 5.52495 7.08804 5.70571L11.988 10.6057L11.9969 10.6146L12.0057 10.6057L16.9057 5.70571C17.0865 5.52495 17.3165 5.43438 17.5969 5.43438C17.8772 5.43438 18.1073 5.52495 18.288 5.70571C18.4688 5.88647 18.5594 6.11652 18.5594 6.39688C18.5594 6.67723 18.4688 6.90728 18.288 7.08804L13.388 11.988L13.3792 11.9969L13.388 12.0057L18.288 16.9057C18.4688 17.0865 18.5594 17.3165 18.5594 17.5969C18.5594 17.8772 18.4688 18.1073 18.288 18.288C18.1073 18.4688 17.8772 18.5594 17.5969 18.5594C17.3165 18.5594 17.0865 18.4688 16.9057 18.288L12.0057 13.388Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.025"
    />
  </svg>
);

export default XIcon;
